<div class="fd-dialog">
  <div class="fd-header">
    <h2 class="fd-title">{{ data?.action === 'edit' ? 'Editar franquicia' : 'Nueva franquicia' }}</h2>
    <button type="button" class="fd-close" aria-label="Cerrar" (click)="closeClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="fd-body">
    <form class="fd-form" [formGroup]="franchiseForm">
      <div class="fd-field">
        <label for="fm-name" class="fd-label">Franquicia</label>
        <input id="fm-name" class="fd-input" type="text" formControlName="name" placeholder="Nombre de la franquicia" required />
        @if (
          franchiseForm.get('name')?.touched &&
          franchiseForm.get('name')?.hasError('required')
        ) {
          <mat-error class="fd-error">Campo obligatorio.</mat-error>
        }
      </div>
      <div class="fd-field">
        <label for="fm-company" class="fd-label">Razón social</label>
        <input id="fm-company" class="fd-input" type="text" formControlName="companyName" placeholder="Razón social" required />
        @if (
          franchiseForm.get('companyName')?.touched &&
          franchiseForm.get('companyName')?.hasError('required')
        ) {
          <mat-error class="fd-error">Campo obligatorio.</mat-error>
        }
      </div>
      <div class="fd-field">
        <label for="fm-cuit" class="fd-label">CUIT</label>
        <input
          id="fm-cuit"
          class="fd-input"
          type="number"
          onKeyPress="if(this.value.length==11) return false;"
          (keydown)="validateOnlyNumbers($event)"
          formControlName="identificationNumber"
          placeholder="CUIT"
          required
        />
        @if (
          franchiseForm.get('identificationNumber')?.touched &&
          franchiseForm.get('identificationNumber')?.hasError('pattern')
        ) {
          <mat-error class="fd-error">El CUIT no puede contener menos de 11 dígitos.</mat-error>
        }
      </div>
      <div class="fd-field">
        <label for="fm-address" class="fd-label">Dirección</label>
        <input id="fm-address" class="fd-input" type="text" formControlName="address" placeholder="Dirección" required />
        @if (
          franchiseForm.get('address')?.touched &&
          franchiseForm.get('address')?.hasError('required')
        ) {
          <mat-error class="fd-error">Campo obligatorio.</mat-error>
        }
      </div>
      <div class="fd-field">
        <label for="fm-city" class="fd-label">Ciudad</label>
        <input id="fm-city" class="fd-input" type="text" formControlName="city" placeholder="Ciudad" required />
        @if (
          franchiseForm.get('city')?.touched &&
          franchiseForm.get('city')?.hasError('required')
        ) {
          <mat-error class="fd-error">Campo obligatorio.</mat-error>
        }
      </div>
      <div class="fd-field">
        <label for="fm-phone" class="fd-label">Teléfono</label>
        <input
          id="fm-phone"
          class="fd-input"
          type="number"
          formControlName="phoneNumber"
          placeholder="Teléfono"
          onKeyPress="if(this.value.length==10) return false;"
          (keydown)="validateOnlyNumbers($event)"
          required
        />
        @if (
          franchiseForm.get('phoneNumber')?.touched &&
          (franchiseForm.get('phoneNumber')?.hasError('pattern') ||
            franchiseForm.get('phoneNumber')?.hasError('required'))
        ) {
          <mat-error class="fd-error">Campo obligatorio. El teléfono no puede contener menos de 10 dígitos.</mat-error>
        }
      </div>
      <div class="fd-field">
        <label for="fm-email" class="fd-label">Email</label>
        <input id="fm-email" class="fd-input" type="text" formControlName="email" placeholder="correo@email.com" required />
        @if (
          franchiseForm.get('email')?.touched &&
          (franchiseForm.get('email')?.hasError('email') ||
            franchiseForm.get('email')?.hasError('required'))
        ) {
          <mat-error class="fd-error">Ingresá un email válido.</mat-error>
        }
      </div>
    </form>
  </div>
  <div class="fd-actions">
    <button mat-stroked-button type="button" (click)="closeClick()">Cancelar</button>
    <button mat-flat-button type="button" (click)="onSubmit()">Guardar</button>
  </div>
</div>
